import { render, staticRenderFns } from "./UserSnippet.vue?vue&type=template&id=a36e3e16"
import script from "./UserSnippet.vue?vue&type=script&lang=js"
export * from "./UserSnippet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports